import { create } from "zustand";
import { persist } from "zustand/middleware";

const useAuthStore = create(
  persist(
    (set) => ({
      isAuthenticated: false,
      user: null,
      client: null,
      token: null,

      login: (userData) => {
        const data = userData?.data || userData;

        // if (data?.token) {
        //   localStorage.setItem("authToken", data.token);
        // }

        // if (data?.user) {
        //   localStorage.setItem("user", JSON.stringify(data.user));
        // }

        // if (data?.client) {
        //   localStorage.setItem("client", JSON.stringify(data.client));
        // }

        set({
          isAuthenticated: true,
          user: data?.user || data,
          client: data?.client || null,
          token: data?.token || null,
        });
      },

      logout: () => {
        // localStorage.removeItem("authToken");
        // localStorage.removeItem("user");
        // localStorage.removeItem("client");

        set({
          isAuthenticated: false,
          user: null,
          client: null,
          token: null,
        });
      },
    }),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
    },
  ),
);

export default useAuthStore;
